import { Fragment } from 'react';
import { graphql } from 'gatsby';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import parse from 'html-react-parser';

import AlubelLogo from '../../images/alubel-logo-gray.svg';
import { NewsletterForm } from '../NewsletterForm';

type FooterProps = {
  data: Queries.FooterFragment;
};

export function Footer({ data }: FooterProps) {
  const { t } = useTranslation();

  const footer = data.contactInfo;

  if (!footer) {
    return null;
  }

  const companyDetails = footer.company_details?.data?.company_details;

  return (
    <footer className='footer'>
      <Link to='/'>
        <AlubelLogo />
      </Link>
      <div className='grid'>
        <div className='newsletter-content'>
          <h5>{t('NEWSLETTER_SUBSCRIPTION')}</h5>

          <NewsletterForm />
        </div>

        <div>
          <div>
            <h5>{t('ADDRESS')}</h5>
            <p>{footer.address?.street_name}</p>
            <p>
              {footer.address?.postal_code} {footer.address?.city} (
              {footer.address?.province}), {footer.address?.country}
            </p>
          </div>

          {companyDetails && parse(companyDetails)}

          <p>© {new Date().getFullYear()} Alubel</p>
          <p>{footer.vat_number}</p>
        </div>

        <div>
          <h5>{t('PHONE_NUMBER')}</h5>
          <p>{footer.phone_number}</p>

          {footer.fax_number && (
            <>
              <h5>{t('FAX')}</h5>
              <p>{footer.fax_number}</p>
            </>
          )}

          <h5>{t('EMAIL')}</h5>
          <p>
            <a href={`mailto:${footer.email}`}>{footer.email}</a>
          </p>
        </div>

        <div>
          <h5>{t('SOCIAL')}</h5>
          <p>
            {footer.socials?.map((social) => {
              if (!social) {
                return null;
              }

              return (
                <Fragment key={social.id}>
                  <a
                    href={social.link!}
                    target={'_blank'}
                    rel={'noreferrer noopener'}
                  >
                    {social.title}
                  </a>
                  <br />
                </Fragment>
              );
            })}
          </p>
        </div>

        <div>
          <h5>Privacy Policies</h5>
          <p>
            {footer.policies?.map((policy) => {
              if (!policy) {
                return null;
              }

              return (
                <Fragment key={policy.id}>
                  <Link to={policy.link!}>{policy.title}</Link>
                  <br />
                </Fragment>
              );
            })}
          </p>
        </div>
      </div>
    </footer>
  );
}

export const query = graphql`
  fragment Footer on Query {
    contactInfo: strapiContactInfo(locale: { eq: $language }) {
      address {
        city
        country
        postal_code
        province
        street_name
      }
      email
      fax_number
      phone_number
      company_details {
        data {
          company_details
        }
      }
      policies {
        id
        link
        title
      }
      socials {
        id
        link
        title
      }
      vat_number
    }
  }
`;
